import { Component } from '@angular/core';
import {Input, OnChanges} from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { TableDataComponent } from '../table-data/table-data.component';


@Component({
    selector: 'app-search-table',
    templateUrl: './search-table.component.html',
    styleUrl: './search-table.component.css',
    imports: [TableDataComponent]
})


export class SearchTableComponent implements OnChanges {
  @Input() dataSource: any ;
  @Input() curInputText: string;
  showApplicationList: boolean = false;
  filteredDs: MatTableDataSource<any>;
  isTableRefreshed: boolean = false;
  pageSizeOptions = [5,10,15];
  localFilterConfig: any;
   TABLE_COLUMNS: any = [
    {
      columnDef: 'app_id',
      header: 'Application ID',
      width: '20%',
      textAlign: 'left',
      sort: true,
      cell: (element: any) => element.app_id
    },
    {
      columnDef: 'app_name',
      header: 'Application Name',
      width: '27%',
      textAlign: 'left',
      sort: true,
      cell: (element: any) => element.app_name
    },
    {
      columnDef: 'aliases',
      header: 'Alias',
      width: '27%',
      textAlign: 'left',
      sort: true,
      cell: ''
    },
    {
      columnDef: 'app_lifecycle_status',
      header: 'Application Life Cycle',
      width: '23% !important',
      textAlign: 'left',
      sort: true,
      cell: (element: any) => element.app_lifecycle_status
    },
    {
      columnDef: 'reset_filter',
      width: '2% !important',
      textAlign:'center',
      header: ' ',
      cell: () =>  ``
    }    
  ];
  
   tableConfig: any = {
    pageSize: 5,
    pageIndex: 0,
    totalItems: 5,
    selection: false,
    expandable: false,
    serverSidePagination: false,
    isPaginatorAttached: false
  };


  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router
  ) {} 

  ngOnChanges() {
    this.initialiazeData();
  }

  initialiazeData(){
    this.isTableRefreshed = false;
    this.filteredDs = new MatTableDataSource([]);
    this.updatePageSizeOptions();
    // Use setTimeout to ensure Angular properly detects the change and re-renders the component
    setTimeout(() => {
      this.updateDataSource();
    }, 0);
  }

  updateDataSource() {
    this.filteredDs = new MatTableDataSource(this.dataSource);
    if(!this.filteredDs){return;}

    this.filteredDs.data = this.dataSource ? this.dataSource : [];
    if (this.curInputText && this.dataSource) {
      const filterValue = this.curInputText.trim().toLowerCase();
      this.filteredDs.data = this.dataSource.filter((item: any) => {
        return (
          item.app_id.toString().toLowerCase().includes(filterValue) ||
          item.app_name.toLowerCase().includes(filterValue)
        );
      });
    } else if (this.dataSource) {
      this.filteredDs.data = this.dataSource;
    } else {
      // Handle the case where dataSource is undefined
      this.filteredDs.data = [];
    }
    this.isTableRefreshed = true;
  }

  searchSpecificApplication(searchedAppId: any, searchAppName:any) {
    const searchedApp = {app_id: searchedAppId, app_name: searchAppName};
    const appId = { app_id: searchedApp.app_id, app_name: searchedApp.app_name, tab: 0 };
    this.showApplicationList = false;
    const params = { appId: JSON.stringify(appId.app_id) };
    this.router.navigate(['application-hub'], { queryParams: params, queryParamsHandling: 'merge' });
  }

  updatePageSizeOptions() {
    if(this.dataSource) {
      const dataSize = this.dataSource.length;
      this.pageSizeOptions = this.calculatePageSizeOptions(dataSize);
    }
  }

  calculatePageSizeOptions(dataSize: number): number[] {
    // Logic to calculate page size options based on data size
    if (dataSize <= 10) {
      return [5, 10];
    } else if (dataSize <= 50) {
      return [10, 25, 50];
    } else {
      return [20, 50, 100];
    }
  }

  addSpaceAfterComma(inputString) {
    if (inputString === null || inputString === undefined) {
        return inputString;
      }
      return inputString.replace(/,/g, ", ");
  }

  openApplication(ev){
    const appData = ev.el;
    this.searchSpecificApplication(appData.app_id, appData.app_name);
  }

}
